import React from 'react';
import { createUseStyles } from 'react-jss'
import "react-lightbox-pack/dist/index.css";

// 
import YImage from '../YImage';
import EventDate from '../EventDate';

var _ = require('lodash');

const useStyles = createUseStyles({
	fieldName: {
		fontWeight: "300",
		fontSize: "13px"
	},
	fieldValue: {
		fontStyle: "italic",
		color: "black",
		fontWeight: "300",
		fontSize: "13px"
	},
})

export default function SingleEvent(props) {
	const classes = useStyles();
	const { auth, event, banner, kategorii, date } = props;

	const playbillSize = "78px";
	
	const _kategorii = (data) => {
		let result = [];
		let mResult = new Map();
		if (data) {
			for (let idx = 0; idx < data.length; idx++) {
				const item = data[idx];
				let kat = mResult.get(item.tantsevalnayaDistsiplinaID);
				if (!kat) {
					kat = {
						tantsevalnayaDistsiplina: item.tantsevalnayaDistsiplina,
						kategoriiUchastnikov: [],
						mKategoriiUchastnikov: new Map(),
					}
					mResult.set(item.tantsevalnayaDistsiplinaID, kat);
					result.push(kat);
				}
				let ok = kat.mKategoriiUchastnikov.get(item.kategoriyaUchastnikovID);
				if (!ok) {
					kat.mKategoriiUchastnikov.set(item.kategoriyaUchastnikovID, data[idx].kategoriyaUchastnikov)
					kat.kategoriiUchastnikov.push(data[idx].kategoriyaUchastnikov);
				}
			}
		}

		for (let idx = 0; idx < result.length; idx++) {
			result[idx].kategoriiUchastnikov.sort((a, b) => a.ID - b.ID);
		}

		result.sort((a, b) => a.tantsevalnayaDistsiplina.ID - b.tantsevalnayaDistsiplina.ID);

		return result
	}
	const kategoriiView = (e) => {
		const list = _kategorii(e.kategoriiUchastnikovNaMeropriyatiyakhMeropriyatie);
		if (list.length <= 0) return <></>;
		return (
			<div key="q4" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
				<div className={classes.fieldName}>Категории:</div>
				<ul style={{ listStyle: "none", paddingInlineStart: "2px", fontSize: "13px" }}>
					{list.map((kat, i) => {
						return <li key={i}>
							{kat.tantsevalnayaDistsiplina.nazvanie + " "}
							({
								kat.kategoriiUchastnikov.map((itemD, idx) => {
									if (idx + 1 < kat.kategoriiUchastnikov.length) {
										return <span key={idx}>{itemD.nazvanie.toLowerCase() + ", "}</span>
									} else {
										return <span key={idx}>{itemD.nazvanie.toLowerCase()}</span>
									}
								})
							})
						</li>
					})}
				</ul>
			</div>
		);
	};
	if (!event) return <></>;
	const appendToArray = (target, source) => {
		if(!target) return source;
		return (!source)? target: [...target, ...source];
	}
	return (
		<div className="event-block" style={{ display: "flex", justifyContent: "space-between" }}>
			<div style={{ maxWidth: "78px" }}>
				{banner && <div style={{ width: playbillSize, height: playbillSize, overflow: "hidden" }}>
					<YImage item={event} width={78}  />
					{/* <YImage image={e.afisha} minimage={e.afishaMin} width={imgSize} /> */}
				</div>}
				{date && <div style={(banner) ? { marginTop: "7px" } : {}}>
					<EventDate event={event} />
				</div>}
			</div>
			<div style={{ flex: "auto", paddingLeft: "7px", lineHeight: "1.2" }}>
				<div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
					{/* <span className={classes.fieldName}>Название: </span> */}
					<a href={`/fed/event/${event.ID}`}>
					<span style={{ fontWeight: "600", fontSize: "14px" }}>{event.nazvanieMeropriyatiya}</span>
					</a>
				</div>
				<div key="q2" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
					<span className={classes.fieldName}>Уровень: </span><span className={classes.fieldValue}>{event.urovenMeropriyatiya.opisanie}</span>
				</div>
				<div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
					<span className={classes.fieldName}>Место проведения: </span>
					<span className={classes.fieldValue}>{event.mestoProvedeniya.name}</span>
				</div>
				{kategorii && kategoriiView(event)}
			</div>
		</div>
	);
}